import { consoleApiSlice } from "./consoleApiSlice";

export const consoleExcelApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadExcel: builder.mutation({
      query: ({ file, scanId, useProd = false }) => {
        const formData = new FormData();
        formData.append("excel", file);
        return {
          url: `excel/upload-excel?scan_id=${scanId}&use_prod=${useProd}`,
          method: "POST",
          body: formData,
          formData: true,
        };
      },
    }),
    deleteExcel: builder.mutation({
      query: ({ scanId, useProd = false }) => ({
        url: `excel/delete-excel?scan_id=${scanId}&use_prod=${useProd}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useUploadExcelMutation, useDeleteExcelMutation } = consoleExcelApiSlice;
